import { toast } from "sonner";
import { Repeat } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiError } from "@/lib/api";
import { setChoice } from "@/lib/edition";

export const EditionCard = () => {
  const { user, setUser } = useAuth();
  const corp = user?.edition === "corporate";
  const next = corp ? "student" : "corporate";
  const swap = async () => {
    if (!window.confirm(`Switch to the ${corp ? "Student" : "Corporate"} edition? Your data stays, only the wording, theme and features change.`)) return;
    try { const { data } = await api.put("/profile/edition", { edition: next }); setChoice(next); setUser(data); toast.success(`Switched to ${corp ? "Student" : "Corporate"}`); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <article data-testid="edition-card" className="card min-w-0 p-5 sm:p-6">
      <div className="flex items-center gap-3">
        <span className="grid place-items-center w-10 h-10 shrink-0 rounded-xl bg-gold-400/15 text-gold-300"><Repeat className="w-5 h-5" /></span>
        <div><h3 className="font-semibold text-slate-900">Edition</h3><p data-testid="edition-current" className="text-sm text-slate-500">You're on the {corp ? "Corporate" : "Student"} edition.</p></div>
      </div>
      <button data-testid="edition-switch" onClick={swap} className="mt-4 rounded-xl border border-slate-300 px-4 py-2.5 text-sm font-semibold text-slate-800 hover:border-gold-400">Switch to {corp ? "Student" : "Corporate"}</button>
    </article>
  );
};
